export function setRealtimeInterval(handler, timeout, runImmediately) {
    let lastLoop = runImmediately ? 0 : new Date().getTime();
    const fn = () => {
        const now = new Date().getTime();
        if (now - lastLoop > timeout) {
            lastLoop = now;
            handler();
        }
    };
    fn();
    // good check interval should be 500-4000ms
    return setInterval(fn, 1000);
}
